<template>
  <v-app light>
    <v-navigation-drawer fixed v-model="drawer" app right temporary>
      <v-list>
        <v-list-tile router to="/" exact>
          <v-list-tile-action>
            <v-icon light>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile router to="/settings" v-if="userIsAuthenticated">
          <v-list-tile-action>
            <v-icon light>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="mt-5 mb-2"></v-divider>
        <v-list-tile router v-if="userIsAuthenticated" @click="onLogout">
          <v-list-tile-action>
            <v-icon light>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Log Out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app color="secondary" dark>
      <v-btn icon @click.stop="goBack" v-if="userIsAuthenticated">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <img src="../static/img/cubo-icon.png" width="50" />
      <v-spacer></v-spacer>
      <v-toolbar-side-icon v-if="userIsAuthenticated" @click.stop="drawer = !drawer" right></v-toolbar-side-icon>
    </v-toolbar>
    <v-content v-if="templates.length > 20 && oldTemplates.length > 10">
      <router-view></router-view>
    </v-content>
    <v-content v-else>
      <v-progress-linear v-model="templates.length" :indeterminate="templates < 1" :query="true"></v-progress-linear>
      <h2 class="text-xs-center display-1">{{ 'Downloading Job Templates' }}</h2>
      <v-progress-linear v-model="templates.length" :indeterminate="templates < 1" :query="true"></v-progress-linear>
    </v-content>
    <update-dialog :dialog="newVersion"></update-dialog>
  </v-app>
</template>

<script>
import { fireStore } from './firebase'
import dbPromise from './dbPromise'

export default {
  data () {
    return {
      drawer: false,
      fixed: false,
      title: 'nexus',
      newVersion: false,
      templates: [],
      oldTemplates: []
    }
  },
  created () {
    fireStore.collection('Versions').doc('App').get()
      .then(doc => {
        if (doc.data().Version !== 3.18) {
          this.newVersion = true
        }
      })
    sessionStorage.removeItem('isSending')
    this.retrieveTemplates()
    this.retrieveOldTemplates()
    this.refreshTemplates()
    this.refreshOldTemplates()
  },
  computed: {
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    onLogout () {
      this.$store.dispatch('logout')
      this.$router.push('/SignIn')
    },
    update () {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
        .then(function (boolean) {
          caches.delete('v1-engineer-cache').then(function (boolean) {
            window.location.reload(true)
          })
        })
    },
    retrieveTemplates () {
      dbPromise().then((db) => {
        let tx = db.transaction('templates')
        let templateStore = tx.objectStore('templates')
        return (templateStore.getAll())
      }).then((val) => {
        console.log(val)
        this.templates = []
        if (val.length > 0) {
          val.forEach(template => {
            this.templates.push(template)
          })
        }
      })
    },
    retrieveOldTemplates () {
      dbPromise().then((db) => {
        let tx = db.transaction('oldTemplates')
        let templateStore = tx.objectStore('oldTemplates')
        return (templateStore.getAll())
      }).then((val) => {
        console.log(val)
        this.oldTemplates = []
        if (val.length > 0) {
          val.forEach(template => {
            this.oldTemplates.push(template)
          })
        }
      })
    },
    refreshTemplates () {
      fireStore.collection('deviceType').get()
        .then((snap) => {
          dbPromise().then((db) => {
            let tx = db.transaction('templates', 'readwrite')
            let currentStore = tx.objectStore('templates')
            currentStore.clear()
            return tx.complete
          })
            .then(() => {
              snap.forEach((doc) => {
                let data = doc.data()
                data.items.forEach((item) => {
                  item.image = ''
                  item.note = ''
                })
                dbPromise().then((db) => {
                  let tx = db.transaction('templates', 'readwrite')
                  let templateStore = tx.objectStore('templates')
                  templateStore.put(data, doc.id)
                  return tx.complete
                }).then(() => {
                  this.templates.push(data)
                })
              })
            })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    refreshOldTemplates () {
      fireStore.collection('Templates').get()
        .then((snap) => {
          dbPromise().then((db) => {
            let tx = db.transaction('oldTemplates', 'readwrite')
            let currentStore = tx.objectStore('oldTemplates')
            currentStore.clear()
            return tx.complete
          })
            .then(() => {
              snap.forEach((doc) => {
                let data = doc.data()
                data.items.forEach((item) => {
                  item.image = ''
                  item.note = ''
                })
                dbPromise().then((db) => {
                  let tx = db.transaction('oldTemplates', 'readwrite')
                  let templateStore = tx.objectStore('oldTemplates')
                  templateStore.put(data, doc.id).length > 10
                  return tx.complete
                }).then(() => {
                  this.oldTemplates.push(data)
                })
              })
            })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
@font-face {
  font-family: "gilroy";
  src: url("../static/fonts/Gilroy-Regular.ttf");
}

.application {
  font-family: "gilroy";
}
</style>


// WEBPACK FOOTER //
// App.vue?ee666ea6